
import React, { useState, createContext } from 'react';

export const FullscreenContext = createContext({ isFullscreen: false });

const FullscreenExpandIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="6" y1="18" x2="18" y2="6" />
        <polyline points="12 6 18 6 18 12" />
        <polyline points="12 18 6 18 6 12" />
    </svg>
);

function ChartFullscreenWrapper({ children, chartTitle = 'Chart', scale = false, onClose = null }) {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const handleDoubleClick = () => {
        setIsFullscreen(true);
    };

    const closeFullscreen = () => {
        setIsFullscreen(false);
        if (onClose && typeof onClose === 'function') {
            onClose();
        }
    };

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            closeFullscreen();
        }
    };

    return (
        <FullscreenContext.Provider value={{ isFullscreen }}>
            <div
                onDoubleClick={handleDoubleClick}
                style={{
                    cursor: 'pointer',
                    userSelect: 'none'
                }}
                title="Double click to open full size chart"
            >
                {children}

                <div
                    onClick={()=> setIsFullscreen(true)}
                    style={{
                        position: "absolute",
                        bottom: 17,
                        left: 45,
                        cursor: 'pointer',
                        color: 'lightgrey',
                        transition: 'all 0.2s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '6px',
                        borderRadius: '4px',
                        zIndex: 10
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#999';
                        e.currentTarget.style.backgroundColor = 'rgba(153, 153, 153, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.color = 'lightgrey';
                        e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    title="Click or double-click to expand chart"
                >
                    <FullscreenExpandIcon />
                </div>
            </div>

            {isFullscreen && (
                <div
                    onClick={handleBackgroundClick}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: '5px'
                    }}
                >
                    {/* GLOBALNE CSS DLA FULLSCREEN */}
                    <style>{`
                        /* Zmiana stylów dla wszystkich ikon pobierania w fullscreen */
                        div[data-fullscreen-content] [data-chart-container] > div:last-child {
                            bottom: 30px !important;
                        }
                        
                        /* Lub dla wszystkich position absolute right 30px */
                        div[data-fullscreen-content] [data-chart-container] [style*="right"] {
                            bottom: 30px !important;
                        }
                        
                        ${scale ? `
                            div[data-fullscreen-content] svg {
                                transform: scale(1.6) !important;
                                transform-origin: center !important;
                                max-width: 100% !important;
                                max-height: 100% !important;
                            }
                        ` : ''}
                    `}</style>

                    <div
                        style={{
                            position: 'absolute',
                            top: 15,
                            right: 15,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: 'calc(100% - 30px)',
                            color: 'white',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            zIndex: 10000
                        }}
                    >
                        <span>{chartTitle}</span>
                        <button
                            onClick={closeFullscreen}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: 'white',
                                fontSize: '32px',
                                cursor: 'pointer',
                                padding: 0,
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            title="Zamknij (Esc)"
                        >
                            ✕
                        </button>
                    </div>

                    <div
                        data-fullscreen-content
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            padding: scale ? '10px' : '10px',
                            width: '98vw',
                            height: '90vh',
                            overflow: 'hidden',
                            marginTop: '40px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '20px'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {children}
                    </div>

                    <div
                        style={{
                            color: 'rgba(255, 255, 255, 0.7)',
                            marginTop: '10px',
                            fontSize: '14px'
                        }}
                    >
                        Press ESC or click X to close
                    </div>
                </div>
            )}

            {isFullscreen && (
                <KeyboardListener onEscape={closeFullscreen} />
            )}
        </FullscreenContext.Provider>
    );
}

function KeyboardListener({ onEscape }) {
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onEscape();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onEscape]);

    return null;
}

export default ChartFullscreenWrapper;